<h1 mat-dialog-title>Adicionar crédito voucher</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: '700';">
  <form [formGroup]="creditoVoucherForm">
    <div class="borda">

      <div class="row">
        <div class="col-sm">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Cliente</mat-label>
            <input type="text" matInput formControlName="cliente">
          </mat-form-field>
        </div>
      </div>

      <div class="row">

        <div class="col-auto">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Pedido referência</mat-label>

            <input type="number" matInput formControlName="pedidoReferencia" required autofocus>
            <mat-error *ngIf="f.pedidoReferencia.errors">
              Campo obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-auto">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Valor do voucher</mat-label>
            <input type="text" matInput formControlName="valorVoucher" required autofocus currencyMask
              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }">
            <mat-error *ngIf="f.valorVoucher.errors">
              O valor mínimo é de R$ 0,01
            </mat-error>
          </mat-form-field>
        </div>

      </div>

      <div class="row">
        <div class="col-sm">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Descrição</mat-label>
            <textarea type="text" multiple matInput formControlName="descricao" required autofocus>
              </textarea>
            <mat-error *ngIf="f.descricao.errors">
              Campo obrigatório deve possuir ao menos 20 caracteres
            </mat-error>
          </mat-form-field>
        </div>
      </div>

    </div>
  </form>

  <mat-divider></mat-divider>

  <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
    <button mat-flat-button color="warn" (click)="cancelar()">
      <mat-icon>clear</mat-icon> Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="confirmarCreditoVoucher()">
      <mat-icon>check</mat-icon> Adicionar voucher
    </button>
  </section>
</div>
